import { StageProvider } from "@hg/recall-frame"
import { useEffect } from "react"

import Toast from "@/components/Toast"
import { i18n } from "@/i18n"
import { collectJumpToRecall } from "@/utils/event"
import { mockSdk, sdkReady } from "@/utils/sdk"
import { msg } from "./const/msg"
import Home from "./Home"

const message = (msg: string) => Toast.message(msg)

const errCodeMsgMap = Object.entries(msg).reduce(
    (acc, [code, key]) => {
        acc[code] = i18n.getRecall(key) || ""
        return acc
    },
    {} as Record<string, string>,
)

const sdkMockReady: () => Promise<any> = async () => mockSdk

const Recall = () => {
    useEffect(() => {
        collectJumpToRecall()
    }, [])

    return (
        <StageProvider
            activityId={__ACTIVITY_CID}
            couponId={__RECALL_COUPON_CID}
            baseURL={__ACT_SERVER_HOST}
            sdkReady={sdkMockReady}
            isMock
            message={message}
            renderMain={() => <Home />}
            errCodeMsgMap={errCodeMsgMap}
        />
    )
}

export default Recall
